export default __webpack_public_path__ + "static/media/polygon.126abce0.png";